import {Box, Grid, useTheme} from '@mui/material';
import HeroDescription from './heroDescription';
import HeroImage from './heroImage';

const HeroLayout = () => {
    const theme = useTheme();

    return (
        <>
            <Box 
                className="sectionSpacing"
                width='100%'
                sx={{
                    backgroundColor: theme.palette.background.default,
                    pt: {xs: 15, md: 20, lg: 25}
                }}
            >
                <Grid
                    direction={{xs: 'column-reverse', md: 'row'}}
                    justifyContent='center'
                    alignItems='center'
                    container
                    width='100%'
                    px='5%'
                >
                    <Grid size={{xs: 12, md: 7}}>
                        <HeroDescription />
                    </Grid>

                    <Grid size={{xs: 12, md: 5}}>
                        <HeroImage />
                    </Grid>
                </Grid>
            </Box>
        </>
    );
}

export default HeroLayout;